// extracted by mini-css-extract-plugin
module.exports = {"quoteblock-root":"Quote_quoteblock-root__U7MJh","arrow-right":"Quote_arrow-right__VwvfD","section-header-large":"Quote_section-header-large__hWx0g"};